
import React, { useState, useEffect } from 'react';
import { OnboardingProvider, useOnboarding } from '@/contexts/OnboardingContext';
import { useAuth } from '@/hooks/useAuth';
import BasicProfileStep from './BasicProfileStep';
// REMOVED: PhotosStep - onboarding no longer requires photo upload
import { InviteChoiceHandler } from './InviteChoiceHandler';

const OnboardingFlow: React.FC = () => {
  const { currentStep, updateData } = useOnboarding();
  const { user } = useAuth();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (user?.email) {
      updateData({ email: user.email });
    }
  }, [user?.email, updateData]);

  // Simple initialization - no complex loading logic
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Show simple loading only during initial mount
  if (!isReady) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500 mb-4 mx-auto"></div>
          <h2 className="text-xl font-semibold text-white mb-2">
            Preparing Onboarding
          </h2>
          <p className="text-gray-300">
            Loading onboarding experience...
          </p>
        </div>
      </div>
    );
  }

  // REMOVED Step2: Onboarding is now 1 step (BasicProfile only)
  // Photo upload is optional and available via ProfilePhotoViewer after onboarding
  const renderCurrentStep = () => {
    switch (currentStep) {
      case 0:
        return <BasicProfileStep />;      // Step 1: Name + DOB (completes onboarding)
      default:
        return <BasicProfileStep />;
    }
  };

  return (
    <div className="min-h-screen">
      {renderCurrentStep()}
    </div>
  );
};

const OnboardingContainer: React.FC = () => {
  return (
    <OnboardingProvider>
      <InviteChoiceHandler>
        <OnboardingFlow />
      </InviteChoiceHandler>
    </OnboardingProvider>
  );
};

export default OnboardingContainer;

